import React from "react";
import {
  TextInput,
  Filter,
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";

import { styles } from "./styles";
import "./index.css";

import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";

import { AccountCreate as create, AccountEdit as edit } from "./Create";

const AccountActions = ({ resource, basePath, refresh }) => (
  <CardActions style={styles.cardActionStyleSmall} className="accounts-actions">
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);

const AccountFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const AccountCreate = create;
export const AccountEdit = edit;

export const AccountsList = props => (
  <List
    {...props}
    actions={<AccountActions />}
    filters={<AccountFilter />}
    title={<IconTitle icon="accounts" title={"resources.accounts.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.accounts.fieldList.name" source="name" />
      <DateField
        label="resources.accounts.fieldList.create_at"
        source="created_at"
      />
      <EditButton label="" style={{ textAlign: "right" }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/accounts/index.js